import { CheckboxBeta } from './CheckboxBeta';

export default CheckboxBeta;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/CheckboxBeta/index.js